import React, { useEffect, useState } from "react";
import Card from "../../../common/Card/Card";
import Table from "../../../common/Table/Table";
import {
  getFiatWithdrawListAction,
  getUserBlncAction,
  getuserBalanceReportAction,
} from "../../../../features/user/userSlice";
import { useDispatch } from "react-redux";
import { formatPrice, toFix } from "../../../../utils/utils";
import Commonpagination from "../../../common/Pagination/Commonpagination";
import { useSelector } from "react-redux";
import format from "date-fns/format";
import Button from "../../../common/Button/Button";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../routes";
import * as XLSX from "xlsx";
import goldCircleCoin from '../../../../assets/icons/coins/goldCircleCoin.svg';
import style from "./Report.module.scss";

const UserReportDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [userBalanceData, setUserBalanceData] = useState([]);
  const [userDetail, setUserData] = useState([]);
  const [loading, setLoading] = useState(true);
  const size = 20;
  const userData = useSelector((state) => state?.persist?.userInfo);
  const decimalLimit = useSelector((state) => state?.users?.coinDecimals);

  const fetchFiatWithdrawHistory = async () => {
    setLoading(true);
    try {
      const response = await dispatch(
        getuserBalanceReportAction({ id: userData?.id })
      );
      if (response?.data?.status === 200) {
        setUserData(response.data.data.list);
        setUserBalanceData(response.data.data.list.rows);
      }
    } catch (error) {
      console.error("Error fetching withdraw list:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchFiatWithdrawHistory();
  }, [page]);

  const tableHeaders = [
    { label: "S.No" },
    { label: "Coin" },
    { label: "Balance" },
    { label: "Action" },
  ];
  const handleViewDetails = (item) => {
    navigate(ROUTES.REPORTDETAILS, { state: { user: item } });
  };

  const handleDownloadInvoice = async (item = {}) => {
    try {
      const response = await dispatch(getUserBlncAction());
      if (response?.status !== 200)
        throw new Error("Failed to fetch user data");

      const userData = response?.data?.data?.data || {};
      const userInfo = Array.isArray(userData?.userInfo)
        ? userData.userInfo[0]
        : {};
      const userDetails = [
        {
          Email: userInfo?.email || "N/A",
          Country: userInfo?.country ? userInfo?.country : "-",
          "Registration Date": userInfo?.created_at
            ? format(new Date(userInfo?.created_at), "MMM dd, yyyy hh:mm a ")
            : "N/A",
          "Total Balance (USD)": userInfo?.usdtTotalBalance || 0,
        },
      ];
      const userCoins = (userData?.combinedBalancesList ?? []).map((coin) => ({
        Coin: coin?.coin_name || "Unknown",
        Balance: coin?.balance || 0,
      }));
      let coinTransactions = {};

      // Iterate over balance_history array
      (userData?.balance_history ?? []).forEach((currencyData) => {
        if (
          !currencyData?.currency_symbol ||
          !Array.isArray(currencyData.transactions)
        )
          return;

        if (!coinTransactions[currencyData.currency_symbol]) {
          coinTransactions[currencyData.currency_symbol] = [];
        }

        // Iterate over transactions inside each currency
        currencyData.transactions.forEach((txn) => {
          coinTransactions[currencyData.currency_symbol].push({
            "Transaction Type": txn.type || "N/A",
            Date: txn.date_time
              ? format(new Date(txn.date_time), "MMM dd, yyyy hh:mm a ")
              : "N/A",
            Amount: txn.amount || 0,
            Balance: txn.balance || 0,
            "Gas Fees": txn.gas_fee ?? 0,
            "Platform Fee": txn.platform_fee ?? 0,
          });
        });
      });

      let wb = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(
        wb,
        XLSX.utils.json_to_sheet(userDetails),
        "User Details"
      );

      if (userCoins.length > 0) {
        XLSX.utils.book_append_sheet(
          wb,
          XLSX.utils.json_to_sheet(userCoins),
          "Coins"
        );
      }

      Object.keys(coinTransactions).forEach((coin) => {
        const transactions = coinTransactions[coin];

        if (transactions.length > 0) {
          const sheetName = coin.length > 31 ? coin.substring(0, 31) : coin;
          XLSX.utils.book_append_sheet(
            wb,
            XLSX.utils.json_to_sheet(transactions),
            sheetName
          );
        } else {
        }
      });

      XLSX.writeFile(wb, `User_${item?.email}_Report.xlsx`);
    } catch (error) {
      console.error("Error generating invoice:", error);
    }
  };

  return (
    <section className={style.repport}>
      <div className={style.repportMainHeading}>
        <h2>Balance Details</h2>
        <div className={style.exportContainer}>
          <Button
            className={style.download_btn}
            onClick={() => handleDownloadInvoice(userDetail)}
          >
            Export
          </Button>
        </div>
      </div>
      <div className={style.repportTopHead}>
        {/* <Card> */}
        <ul>
          <li>
            <label>Email</label>
            <h4>{userDetail?.email}</h4>
          </li>
          <li>
            <label>Country</label>
            {/* <h4>{userDetail?.country ? userDetail?.country : "-"}</h4> */}
            <h4>
              {userDetail?.country &&
                userDetail.country.toLowerCase() !== "unknown"
                ? userDetail.country
                : "-"}
            </h4>
          </li>
          <li>
            <label>Registration Date</label>
            <h4>
              {userDetail?.registrationDate &&
                format(
                  new Date(userDetail?.registrationDate),
                  "MMM dd, yyyy hh:mm a ",
                )}
            </h4>
          </li>
          <li>
            <label>Available Balance (USD)</label>
            <h4>{formatPrice(userDetail?.usdBalance)}</h4>
          </li>
        </ul>
        {/* </Card> */}
      </div>

      <div className={style.repportTable}>
        {/* <Card className={style.investments} headerClassName={style.header}> */}
        <div className="tab_data">
          <Table
            noRecordContent={"No records were found."}
            noRecordClassName={style.no_content}
            noContentVariant="large"
            loading={loading}
            loadingClassName={"loading_table"}
            className={style.table}
            fields={tableHeaders}
          >
            {userBalanceData?.length > 0 ? (
              userBalanceData.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>
                    <div className="coin_details">
                      {/* <span className='coin_icon'>
                        <img src={goldCircleCoin} alt="coin" />
                      </span> */}
                      {item?.coin_name}
                    </div>
                  </td>
                  <td>
                    {item?.balance != 0
                      ? toFix(item?.balance, decimalLimit[item?.coin_name])
                      : 0}
                  </td>
                  <td>
                    <Button
                      variant="text_blue"
                      className="detail_btn"
                      onClick={() => handleViewDetails(item)}
                    >
                      View Details
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={tableHeaders.length}
                  style={{ textAlign: "center" }}
                >
                  No records found!
                </td>
              </tr>
            )}
          </Table>

          {userBalanceData?.totalPages > 1 && (
            <Commonpagination
              pagination
              currentPage={page}
              className={style.pagination}
              pageSize={size}
              totalPages={userBalanceData?.totalPages}
              handlePageChange={(selected) => setPage(selected)}
            />
          )}
        </div>
        {/* </Card> */}
      </div>
    </section>
  );
};

export default UserReportDetails;
